import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IMetadatas } from '../../app/apiSlice';


export enum StorageSpaceTypes {
    S3 = 'S3',
    KAFKA = 'KAFKA'
}

export interface Source {
    id:number | null,
    domaine:any,
    nom:string,
    description:string,
    protocole:string | null,
    uri:string,
    utilisateur:string,
    motDePasse:string,
    organisme:string,
    typeDeDonnee:{name:string} |null,
    formatDeDonnee:string |null,
    CustomMetaData:MetaData[],
    espaceDeStockageName:string|null,
    espaceDeStockageValue:string|null,
    choiceEspaceDeStockage:StorageSpaceTypes|null,
    espaceDeStockage:any
    sas:boolean,
    protocoleDatas:MetaData[],
    selectedLabels:IMetadatas
}

export interface MetaData {
    name:string,
    value:string
}

export interface Metadonees {
    id:number,
    libelle:string,
    nom:string,
    type:string
    value?:any
}

export interface Protcole {
    id: number,
    nom: string,
    uriPattern:string
    refMetadonnees:Metadonees[]
}

export interface CdsState {
    // current topology 
    url: string
    protocole: Protcole[] | undefined;
    source: Source ;
    statusRowDelete: any;
    domainePagination: DomainePagintation
}

export interface DomainePagintation {
    search: string
    sort: "ASC" | "DESC"
    page: number,
    size: number,
    field: "libelle"
}

export const initialState: CdsState = {
    url: "https://proxy.admin.artemis/smd/pds-nifi-workflow?guid=&urlRetour=",
    protocole: undefined,
    source: {
        id:null,
        domaine: null,
        nom:"",
        description:"",
        protocole:null,
        uri:"",
        utilisateur:"",
        motDePasse:"",
        organisme:"",
        typeDeDonnee:null,
        formatDeDonnee:null,
        CustomMetaData:[],
        espaceDeStockageName:null,
        espaceDeStockageValue:null,
        sas:true,
        choiceEspaceDeStockage:null,
        protocoleDatas:[],
        espaceDeStockage:null,
        selectedLabels: {}
    },
    statusRowDelete: false,
    domainePagination: {
        field :"libelle",
        search:"",
        sort:"ASC",
        page: 0,
        size: 7
    }
};



export const cdsSlice = createSlice({
    name: 'cds',
    initialState,
    reducers: {
        resetCdsSlice: () => initialState,
        setSearchDomainePagination: (state, action: PayloadAction<string>) => {
            state.domainePagination.search = action.payload
        },
        setPageDomainePagination: (state, action: PayloadAction<number>) => {
            state.domainePagination.page = action.payload
        },
        setSizeDomainePagination: (state, action: PayloadAction<number>) => {
            state.domainePagination.size = action.payload
        },
        setDomainePagination: (state, action: PayloadAction<DomainePagintation>) => {
            state.domainePagination = action.payload
        },
        setProtocole: (state, action: PayloadAction<any>) => {
            state.protocole = action.payload;
        },
        deleteCustomMeteData: (state, action: PayloadAction<{nom:string,valeur:string}>) => {
            for (let i = 0; i < state.source.CustomMetaData.length; i++) {
                console.log(state.source.CustomMetaData[i])
                if (state.source.CustomMetaData[i].name === action.payload.nom && state.source.CustomMetaData[i].value === action.payload.valeur) {
                    state.source.CustomMetaData.splice(i, 1);
                  break;
                }
              }
        },
        setSource: (state, action: PayloadAction<any>) => {
            if(action.payload.id || action.payload.id === null)state.source.id = action.payload.id;
            if(action.payload.espaceDeStockageValue || action.payload.espaceDeStockageValue === null)state.source.espaceDeStockageValue = action.payload.espaceDeStockageValue;
            if(action.payload.domaine || action.payload.domaine === null)state.source.domaine = action.payload.domaine;
            if(action.payload.nom || action.payload.nom==="")state.source.nom = action.payload.nom;
            if(action.payload.description || action.payload.description==="")state.source.description = action.payload.description;
            if(action.payload.CustomMetaData)state.source.CustomMetaData = action.payload.CustomMetaData;
            if(action.payload.protocoleDatas)state.source.protocoleDatas = action.payload.protocoleDatas;
            if(action.payload.uri || action.payload.uri==="")state.source.uri = action.payload.uri;
            if(action.payload.utilisateur || action.payload.utilisateur==="")state.source.utilisateur = action.payload.utilisateur;
            if(action.payload.motDePasse || action.payload.motDePasse==="")state.source.motDePasse = action.payload.motDePasse;
            if(action.payload.organisme || action.payload.organisme==="")state.source.organisme = action.payload.organisme;
            if(action.payload.protocole || action.payload.protocole === null)state.source.protocole = action.payload.protocole;
            if(action.payload.organisme || action.payload.organisme==="")state.source.organisme = action.payload.organisme;
            if(action.payload.formatDeDonnee || action.payload.formatDeDonnee === null)state.source.formatDeDonnee = action.payload.formatDeDonnee;
            if(action.payload.typeDeDonnee || action.payload.typeDeDonnee === null) state.source.typeDeDonnee = action.payload.typeDeDonnee;
            if(action.payload.espaceDeStockageName || action.payload.espaceDeStockageName === null)state.source.espaceDeStockageName = action.payload.espaceDeStockageName;
            if(action.payload.espaceDeStockage || action.payload.espaceDeStockage === null)state.source.espaceDeStockage = action.payload.espaceDeStockage;
            if(action.payload.sas || action.payload.sas === false)state.source.sas = action.payload.sas;
            if(action.payload.choiceEspaceDeStockage || action.payload.choiceEspaceDeStockage === null)state.source.choiceEspaceDeStockage = action.payload.choiceEspaceDeStockage;
            if(action.payload.selectedLabels) state.source.selectedLabels = action.payload.selectedLabels;

        },
        setDeletedRow: (state, action: PayloadAction<any>) => {
            state.statusRowDelete = action.payload
        },

    },

});

export const {
    setProtocole,
    setSource,
    setDeletedRow,
    deleteCustomMeteData,
    setSearchDomainePagination,
    setPageDomainePagination,
    setSizeDomainePagination,
    setDomainePagination,
    resetCdsSlice
} = cdsSlice.actions;

export default cdsSlice.reducer;